import { withNamespaces, Trans } from "react-i18next";

const NoDataFound = ({ t, themeColor="purp" }) => (
  <div className={`alert text-90 brc-${themeColor}-l1 text-grey-d3 mb-0`} role="alert">
    <i className={`fa fa-info-circle mr-1 text-${themeColor}`}></i> {t("noDataFound")}
  </div>
);
export default withNamespaces("common")(NoDataFound);